import { Loader } from "../../../components/shared/index";
import { Products } from "../../../components/web-app/index";
import { useGetWishLists } from "../../../queries/useWishListQuery";
import styles from "./productdetails.module.css";

const RelatedProducts = ({ relatedProducts = [], isPending }) => {
  const {
    data: wishItems = [],
    isPending: isWishListPending,
  } = useGetWishLists();

  if (isPending) {
    return <Loader title="Loading related products..." />;
  }

  if (!relatedProducts.length) {
    return <p>No related products found</p>;
  }

  return (
    <div className={styles.relatedproduct__wrapper}>
      <Products
        title="Related Products"
        category=""
        products={relatedProducts}
        wishItems={wishItems}
        isWishListPending={isWishListPending}
      />
    </div>
  );
};

export default RelatedProducts;